import React from "react";
import PropTypes from "prop-types";
import { percentOfNumber } from "../../utils";
import BackgroundVerticalLines from "./BackgroundVerticalLines";

import VerticalStick from "./VerticalStick";

const VerticalBar = ({
  data,
  tag,
  maxValue,
  isVisible,
  hasBackgroundLines, 
  numberOfBars
}) => {
  let id = 0;

  return (
    <div className="vertical-bar" style={{ width: `calc(100%/${numberOfBars}` }}>
      <div className="vertical-bar__bars">
        <BackgroundVerticalLines />
        {data.map((value, index) =>(
            <VerticalStick
              key={`${tag}-${id++}`}
              height={percentOfNumber(value, maxValue) || 2}
              value={value === "Infinity" || value === null ? 0 : value }
              isEven={index % 2 === 0}
              isVisible={isVisible}
            />
          ))}
      </div>
      <span className="vertical-bar__key">{tag}</span>
    </div>
  );
};

VerticalBar.propTypes = {
  data: PropTypes.object,
  isVisible: PropTypes.bool,
  maxValue: PropTypes.number,
  tag: PropTypes.string
};

VerticalBar.defaultProps = {
  data: {},
  isVisible: false,
  maxValue: 0,
  tag: ""
};

export default VerticalBar;
